import * as z from "zod";
import { OC } from "../../utils";
import { AdminAuditLog } from "./schema";

export const auditLogContract = OC.router({
  getAll: OC.meta({ permissions: true })
    .input(AdminAuditLog.GetAll)
    .output(
      z.array(
        AdminAuditLog.AuditLog.extend({
          number: z.number(),
        }),
      ),
    ),
});
